/* The design picker drives the gallery AND would drive the Shopify variant.
   On the real page the Buy Button component is created with options:true for
   10367463326010, so this control is Shopify's own selector, restyled — the
   gallery simply listens to it. Nothing here is new commerce wiring. */
(function(){
  var gal=document.getElementById('gal');
  document.querySelectorAll('.opt').forEach(function(b){
    b.addEventListener('click',function(){
      document.querySelectorAll('.opt').forEach(function(o){o.setAttribute('aria-pressed','false')});
      b.setAttribute('aria-pressed','true');
      gal.setAttribute('data-active', b.dataset.design);
    });
  });
})();

(function(){
  var lb = document.getElementById('lightbox');
  if (!lb) return;
  var big = lb.querySelector('img'),
      fig = lb.querySelector('.lb-figure'),
      btnClose = lb.querySelector('.lb-close'),
      btnPrev  = lb.querySelector('.lb-prev'),
      btnNext  = lb.querySelector('.lb-next');

  /* A gallery per product, read from the page. The towel's two images are one
     gallery; all four ferrule photographs are the other, in reading order. */
  var galleries = [];
  function collect(sel, label){
    var imgs = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (imgs.length) galleries.push({ label: label, imgs: imgs });
  }
  collect('.stage img, .strip img', 'Ultimate Caddy Towel');
  collect('.demo-grid img', 'Ultimate Caddy Towel — what it does');
  collect('#gal .design[data-design="jailbird"] .swap img', 'TOURSPECWRX Signature Ferrules — Classy Jailbird');
  collect('#gal .design[data-design="thunder"] .swap img', 'TOURSPECWRX Signature Ferrules — Gray Thunder');

  /* A pointer that can hover gets the swap for free and can spend the click on
     zoom. A touch screen has no hover, so there the TAP swaps and the explicit
     zoom control is the only way in — otherwise one gesture would have to mean
     two things. */
  var HOVER = window.matchMedia('(hover: hover)').matches;

  var current = null, index = 0, lastFocus = null, scrollY = 0;

  galleries.forEach(function(g){
    g.imgs.forEach(function(img, i){
      var mount = img.closest('.swap, .frame, .obj, .strip figure') || img;
      var isSwap = mount.classList.contains('swap');
      /* both images of a swap frame share one mount — wire it once */
      if (isSwap && mount.dataset.lbBound) return;
      mount.classList.add('zoomable');
      mount.setAttribute('role', 'button');
      mount.setAttribute('tabindex', '0');
      mount.setAttribute('aria-label', isSwap
        ? ('Enlarge ' + g.label)
        : ('Enlarge image ' + (i + 1) + ' of ' + g.imgs.length + ', ' + g.label));
      /* HOVER and CLICK are two different jobs (CEO 2026-08-19):
         hover = see it INSTALLED up close · click = inspect the ACTUAL FERRULES.
         So a swap frame always opens the viewer on its product photo (index 0),
         never on whichever view the pointer happens to be showing. The installed
         shot is still in the gallery, one arrow away. */
      function at(){ return isSwap ? 0 : i; }
      function open(e){ e.preventDefault(); show(g, at(), mount); }
      if (isSwap){
        mount.dataset.lbBound = '1';
        mount.addEventListener('click', function(e){
          if (e.target.closest('.zoom-btn')){ open(e); return; }
          if (HOVER){ open(e); }
          else { e.preventDefault();
                 mount.dataset.shown = mount.dataset.shown === 'alt' ? 'rest' : 'alt'; }
        });
      } else {
        mount.addEventListener('click', open);
      }
      mount.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') open(e);
      });
    });
  });

  function render(){
    var img = current.imgs[index];
    /* CEO 2026-08-19: the enlarged image must be high-resolution, never an upscaled
       thumbnail. data-full names the largest file we hold for that photograph; the
       page's own (smaller) rendition is only the fallback. maxZoom() below then
       derives its ceiling from THIS file's natural pixels. */
    big.src = img.dataset.full || img.currentSrc || img.src;
    big.alt = img.alt || '';
    lb.setAttribute('aria-label', current.label + ', image ' + (index + 1) + ' of ' + current.imgs.length);
    if (current.imgs.length < 2) lb.setAttribute('data-single', ''); else lb.removeAttribute('data-single');
    resetZoom();
  }

  /* ========================================================================
     ZOOM AND PAN
     The image opens fitted. From there it can be magnified far enough to reach
     its own native pixels — that is the point at which the sales card's fine
     print is as sharp as the file allows, and no magnification beyond it adds
     real detail. maxScale is therefore computed per image from the ratio of its
     natural width to its fitted width, never hard-coded.
     ======================================================================== */
  var scale = 1, tx = 0, ty = 0;

  /* The ceiling is derived from the file, never cached and never hard-coded.
     natural/fitted is the factor at which the image reaches its own native pixels -
     the sharpest it can ever be. A floor of 2.5 is allowed above that so small
     print is comfortably large rather than merely sharp, and 4 is an absolute cap
     past which there is only softness. Computed on every call because an earlier
     version cached it at load, measured the image before layout had settled, and
     let the sales card blow up to 6x - 318% of its native pixels, pure blur. */
  function maxZoom(){
    var fitted = big.offsetWidth || 1;   /* layout width, unaffected by the transform */
    return Math.min(4, Math.max(2.5, big.naturalWidth / fitted));
  }

  function apply(){
    big.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    if (scale > 1.01) big.setAttribute('data-zoomed', ''); else big.removeAttribute('data-zoomed');
  }

  function resetZoom(){
    scale = 1; tx = 0; ty = 0;
    big.style.transition = '';
    apply();
  }

  /* keep the image from being dragged off into empty space */
  function clamp(){
    var f = fig.getBoundingClientRect(), w = big.offsetWidth * scale, h = big.offsetHeight * scale;
    if (w <= f.width) tx = (f.width - w) / 2; else tx = Math.min(0, Math.max(f.width - w, tx));
    if (h <= f.height) ty = (f.height - h) / 2; else ty = Math.min(0, Math.max(f.height - h, ty));
  }

  /* zoom about a point, so whatever is under the cursor or fingers stays put */
  function zoomAt(clientX, clientY, next){
    next = Math.min(maxZoom(), Math.max(1, next));
    var r = big.getBoundingClientRect();
    var ox = clientX - r.left, oy = clientY - r.top;
    var k = next / scale;
    tx -= ox * (k - 1); ty -= oy * (k - 1);
    scale = next;
    if (scale <= 1.001){ scale = 1; tx = 0; ty = 0; big.style.transform = ''; big.removeAttribute('data-zoomed'); return; }
    clamp(); apply();
  }

  big.addEventListener('wheel', function(e){
    e.preventDefault();
    /* ctrlKey is what a trackpad pinch reports; both gestures drive the same path */
    var factor = Math.exp(-e.deltaY * (e.ctrlKey ? 0.012 : 0.0022));
    big.style.transition = '';
    zoomAt(e.clientX, e.clientY, scale * factor);
  }, {passive:false});

  big.addEventListener('dblclick', function(e){
    e.preventDefault();
    big.style.transition = 'transform 200ms cubic-bezier(.2,.65,.3,1)';
    zoomAt(e.clientX, e.clientY, scale > 1.01 ? 1 : maxZoom());
    setTimeout(function(){ big.style.transition = ''; }, 220);
  });

  /* drag to pan, mouse and single-finger touch, only once magnified */
  var dragging = false, px = 0, py = 0, moved = 0;
  big.addEventListener('pointerdown', function(e){
    if (scale <= 1.01 || e.pointerType === 'touch' && pinching) return;
    dragging = true; moved = 0; px = e.clientX; py = e.clientY;
    big.setAttribute('data-panning', '');
    if (big.setPointerCapture) big.setPointerCapture(e.pointerId);
  });
  big.addEventListener('pointermove', function(e){
    if (!dragging) return;
    e.preventDefault();
    tx += e.clientX - px; ty += e.clientY - py;
    moved += Math.abs(e.clientX - px) + Math.abs(e.clientY - py);
    px = e.clientX; py = e.clientY;
    clamp(); apply();
  });
  function endDrag(){ dragging = false; big.removeAttribute('data-panning'); }
  big.addEventListener('pointerup', endDrag);
  big.addEventListener('pointercancel', endDrag);

  /* pinch to zoom, two fingers */
  var pinching = false, startDist = 0, startScale = 1;
  function dist(t){ var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
  big.addEventListener('touchstart', function(e){
    if (e.touches.length !== 2) return;
    pinching = true; dragging = false;
    startDist = dist(e.touches); startScale = scale;
  }, {passive:true});
  big.addEventListener('touchmove', function(e){
    if (!pinching || e.touches.length !== 2) return;
    e.preventDefault();
    var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2,
        my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
    zoomAt(mx, my, startScale * (dist(e.touches) / (startDist || 1)));
  }, {passive:false});
  big.addEventListener('touchend', function(e){ if (e.touches.length < 2) pinching = false; }, {passive:true});

  function show(gallery, i, trigger){
    current = gallery; index = i; lastFocus = trigger || document.activeElement;
    render();
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.top = (-scrollY) + 'px';
    document.body.classList.add('lb-locked');
    lb.hidden = false;
    lb.removeAttribute('data-closing');
    lb.style.animation = '';
    fig.style.animation = '';
    lb.setAttribute('data-open', '');
    /* HARD GUARANTEE OF VISIBILITY. The entry animation is decoration; after its
       duration it is removed outright so the resting opacity:1 governs. Without this,
       any context whose animation clock does not advance (verified during testing:
       currentTime stayed at 0) leaves the overlay painted at the keyframe's from-state
       - invisible, while the page underneath is already scroll-locked. */
    setTimeout(function(){
      lb.style.animation = 'none';
      fig.style.animation = 'none';
    }, 220);
    btnClose.focus();
  }

  var closing = false;
  function hide(){
    if (closing || lb.hidden) return;
    closing = true;
    lb.setAttribute('data-closing', '');
    /* a plain timer, NOT animationend/transitionend: if the animation clock is frozen
       those events never fire and the page would stay locked behind the overlay
       forever. The timer always fires, so closing can never hang. */
    setTimeout(function(){
      lb.removeAttribute('data-open');
      lb.removeAttribute('data-closing');
      lb.hidden = true;
      document.body.classList.remove('lb-locked');
      document.body.style.top = '';
      /* Force layout BEFORE restoring. While locked, body is position:fixed, so the
         document collapses to viewport height and the maximum scroll offset is ~0.
         Without this read the browser clamps the restore to 0 and the customer is
         thrown back to the top of the page - verified failing before this line. */
      void document.body.offsetHeight;
      /* 'instant' because the page sets scroll-behavior:smooth, which would otherwise
         animate the restore and can be interrupted mid-flight. */
      window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
      /* preventScroll is essential, not defensive: focus() scrolls its target into
         view, so returning focus to the thumbnail scrolled the page to that card and
         silently undid the position restore one line above. Measured failing without
         it - a click near the page bottom returned the reader ~66px off, and one near
         the top threw them back to 0. */
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      closing = false;
    }, 160);
  }

  function step(n){
    if (!current || current.imgs.length < 2) return;
    index = (index + n + current.imgs.length) % current.imgs.length;
    render();
  }

  btnClose.addEventListener('click', hide);
  btnPrev.addEventListener('click', function(){ step(-1); });
  btnNext.addEventListener('click', function(){ step(1); });
  /* clicking the dimmed ground closes; clicking the photograph does not */
  /* Clicking the dimmed ground closes; clicking the photograph does not. The moved
     guard matters once zooming exists: a pan that drifts onto the ground and releases
     there would otherwise register as a click-outside and shut the viewer mid-read. */
  lb.addEventListener('click', function(e){
    if (moved > 6){ moved = 0; return; }
    if (e.target === lb || e.target.classList.contains('lb-figure')) hide();
  });

  document.addEventListener('keydown', function(e){
    if (lb.hidden) return;
    if (e.key === 'Escape'){ e.preventDefault(); hide(); }
    else if (e.key === 'ArrowLeft'){ e.preventDefault(); step(-1); }
    else if (e.key === 'ArrowRight'){ e.preventDefault(); step(1); }
    else if (e.key === 'Tab'){
      /* focus stays inside the dialog while it is open */
      var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function(b){ return b.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
  });

  /* Swipe, mobile. Suppressed while the image is magnified: at that point a
     horizontal drag means "pan to read the rest of this card", not "next image". */
  var x0 = null, y0 = null;
  lb.addEventListener('touchstart', function(e){
    if (e.touches.length !== 1 || scale > 1.01){ x0 = null; return; }
    x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
  }, {passive:true});
  lb.addEventListener('touchend', function(e){
    if (x0 === null || scale > 1.01){ x0 = null; return; }
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    x0 = y0 = null;
  }, {passive:true});
})();

(function(){
  var v={jailbird:'53766898057530',thunder:'53766898090298'};
  var f=document.getElementById('fer-variant');
  document.querySelectorAll('.opt').forEach(function(b){
    b.addEventListener('click',function(){ if(f) f.value=v[b.dataset.design]; });
  });
})();